import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { doSetResetModal } from '../../store/slices/Modal';
import styled from 'styled-components';
import Button from '../atoms/Button';

const SuccessModal = () => {
  const modal = useSelector((state) => state.Modal);

  const dispatch = useDispatch()

  const handleOk = () => {
    dispatch(doSetResetModal());
  };

  const handleCancel = () => {
    dispatch(doSetResetModal());
  };

  return (
    <StyledModal isOpen={modal.isShowSuccess} toggle={handleOk} centered={true}>
      <ModalHeader toggle={handleOk}>Success!</ModalHeader>
      <ModalBody>
        <span>{modal.description}</span>
      </ModalBody>
      <ModalFooter>
        <StyledButton onClick={handleCancel} color="primary">
          Ok
        </StyledButton>
      </ModalFooter>
    </StyledModal>
  );
};

export default SuccessModal;

const StyledButton = styled(Button)`
  width: 64px;
  height: 30px;
  border-radius: 5px;
  border: #D9D9D9;

  :hover {
    background-color: #D9D9D9;
  }
`

const StyledModal = styled(Modal)`

  .modal-content { 
    width: 350px !important;
  }

  .modal-header {
    padding: 10px 20px;
    border-top: 1px solid #FFFFFF;
    border-bottom: 1px solid #2E2E2E;
  }
  .modal-body {
    padding: 20px 20px;
    width: 350px !important;
    /* padding: 0px 30px 35px 30px; */
  }
  .modal-footer {
    padding: 10px 30px;
  }
  
`